
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftRight100 as ObiThreewayAcuatorPistonInleftRight100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-right-100.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftRight100 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-right-100',
   elementClass: ObiThreewayAcuatorPistonInleftRight100Element,
   events: {
     
   }
  });
 
 